export default "__VITE_ASSET__CmC9Jx20__"